import React from 'react';
import CorporationProvider from "./context/corporation-context.jsx";
import CorporationInit from "./components/corporation-init.jsx";

const CorporationForm = () => {
    return (
        <CorporationProvider>
            <CorporationInit />
        </CorporationProvider>
    );
}

export default CorporationForm;